// ====================================================================================
// eyeAble.module
// ====================================================================================

export const init = () => {
  let attempts = 0;
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      // check if EyeAbleAPI is available
      if (typeof EyeAbleAPI === "undefined") {
        console.error("EyeAbleAPI is not available");
        return;
      } else {
        let contrastButton = document.querySelector(".as-eyeable__contrast");
        if (contrastButton) {
          contrastButton.addEventListener("click", () => {
            let mode = EyeAbleAPI.getColorMode();
            if (mode === "Darkmode") {
              // console.log("contrastButton disabled");
              // EyeAbleAPI.disableContrast();
              EyeAbleAPI.toggleDarkmode();
              contrastButton.classList.remove("enabled");
            } else {
              // console.log("contrastButton enabled");
              // EyeAbleAPI.toggleContrast();
              // EyeAbleAPI.enableContrast("rgb(9, 121, 170)","rgb(255, 255, 255)");
              // EyeAbleAPI.enableContrast("rgb(0, 116, 148)","rgb(255, 255, 255)");
              EyeAbleAPI.toggleDarkmode();
              contrastButton.classList.add("enabled");
            }
          });
        }
      }
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
